<svg width="200" height="200" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
  <defs>
    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#009fe3" />
      <stop offset="100%" stop-color="#2fd566" />
    </linearGradient>
  </defs>
  <circle cx="50" cy="50" r="30" />
</svg>
